
import styled, { keyframes } from 'styled-components';
import { fadeIn, fadeOut, slideInDown, flipInY, fadeInDown,flipInX, bounceIn } from 'react-animations';

const fadeInAnimation = keyframes`${fadeIn}`;
const FadeInDiv = styled.div`
  animation: 1s ${fadeInAnimation};
`;

const fadeOutAnimation = keyframes`${fadeOut}`;
const FadeOutDiv = styled.div`
  animation: 1s ${fadeOutAnimation};
`;

const slideInDownAnimation = keyframes`${slideInDown}`;
const SlideInDownDiv = styled.div`
  animation: 1s ${slideInDownAnimation};
`;

const flipInYAnimation = keyframes`${flipInY}`;
const FlipInYDiv = styled.div`
  animation: 1s ${flipInYAnimation};
`;

const flipInXAnimation = keyframes`${flipInX}`;
const FlipInXDiv = styled.div`
  animation: 1s ${flipInXAnimation};
`;

const bounceInAnimation = keyframes`${bounceIn}`;
const BounceInDiv = styled.div`
  animation: 1s ${bounceInAnimation};
`;

const fadeInDownAnimation = keyframes`${fadeInDown}`;
const FadeInDownDiv = styled.div`
  animation: 1s ${fadeInDownAnimation};
`;

export { FadeInDiv, FadeOutDiv, SlideInDownDiv, FlipInYDiv, FadeInDownDiv, FlipInXDiv, BounceInDiv }